import { Component, ViewChild, OnInit, OnDestroy, Renderer2, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationCountService } from "src/app/services/notificationCountService";
import { SessionService } from "src/app/services/session.service";
import { ModalAuthService } from "src/app/services/ux/modal-auth.service";
import { MobileNavComponent } from "./mobile/mobile-nav.component";
import { environment } from "src/environments/environment";
import { UserHttpClientService } from "../../../data/user-http-client.service";
import { User } from "../../../models/User/user";
import { Subscription } from "rxjs/internal/Subscription";
import { SetTitleService } from "src/app/services/set-title.service";

@Component({
  selector: "main-navbar",
  templateUrl: "nav.component.html",
  styleUrls: ["./nav.component.css"]
})
export class NavComponent {
  @ViewChild(MobileNavComponent)
  private mobileNav: MobileNavComponent;

  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu: ElementRef;

  notificationCount: number;
  environment: any
  isBanking: boolean = environment.env === "banking"
  useSidebar: boolean = environment.useSidebar
  isOpenProfileContent: boolean = false
  user: User;
  userInfo$ = new Subscription();
  subscription: Subscription;
  title: any;

  constructor(
    private _authModalService: ModalAuthService,
    public session: SessionService,
    private router: Router,
    private notificationService: NotificationCountService,
    private userService: UserHttpClientService,
    private settitleservice: SetTitleService,
    private renderer: Renderer2
  ) {
    this.environment = environment;
    if (session.isLoggedIn()) {
      this.notificationService.getNotificationCount();
      // * subscribe to notification count service
      this.notificationService.count.subscribe(
        (count) => (this.notificationCount = count)
      );
    }
    this.renderer.listen('window', 'click', (e: Event) => {
      /**
       * Only run when toggleButton is not clicked
       * If we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * And the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
      if (this.isOpenProfileContent) {
        if (e.target !== this.toggleButton.nativeElement && e.target !== this.menu.nativeElement) {
          this.isOpenProfileContent = !this.isOpenProfileContent
        }
      }
    });

    this.subscription = this.settitleservice.getTitle().subscribe(title => {
      this.title = title.text;
    });
  }

  ngOnInit() {
    if (this.session.isLoggedIn()) {
      this.userInfo$ = this.userService.getUserDetails().subscribe((_user: User) => { });
    }

    this.userService.user.subscribe(data => this.user = data)
  }

  ngOnDestroy() {
    this.userInfo$.unsubscribe();
  }

  toggle() {
    this.mobileNav.toggleSideBar();
  }

  openAuthModal() {
    this._authModalService.open();
  }

  toggleProfileContent() {
    this.isOpenProfileContent = !this.isOpenProfileContent
  }

  /**
   * @TODO: logout in backend
   */
  logout() {
    this.session.logout();
    this.toggleProfileContent()
    this.router.navigate(["/"]);
  }

  getUserName() {
    if (!this.user) return ""
    return `${this.user.first_name} ${this.user.last_name}`
  }

  getUserAvatarText() {
    if (!this.user) return ""
    if (!!this.user.administrator_last_name && !!this.user.administrator_first_name) return `${this.user.administrator_first_name[0]}${this.user.administrator_last_name[0]}`

    return `${this.user.first_name[0]}${this.user.last_name[0]}`
  }

  redirectToResgisterPage() {
    this.router.navigate(["/register"])
  }
}
